// EmptyState — 1:1 port of legacy `src/ui/EmptyState.jsx`.
import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';
import { useTranslation } from 'react-i18next';

export interface EmptyStateProps {
  icon?: IconName;
  title?: string;
  text?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = 'package', title, text, action }: EmptyStateProps) {
  const { t } = useTranslation('common');
  const resolvedTitle = title ?? t('states.emptyTitle');
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        color: 'var(--fg-2)',
        gap: 10,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 'var(--r-full)',
          background: 'var(--bg-2)',
          color: 'var(--fg-3)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name={icon} size={22} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--fg-1)' }}>{resolvedTitle}</div>
      {text && <div style={{ fontSize: 13, maxWidth: 520 }}>{text}</div>}
      {action}
    </div>
  );
}
